export const categories = [
  {
    id: 'wanghong-heiliao',
    name: '网红黑料',
    slug: 'wanghong-heiliao',
    description: '每日更新网红翻车现场，深扒网红不为人知的内幕',
    icon: 'ri-fire-line',
    count: 128,
  },
  {
    id: 'meiri-chigua',
    name: '每日吃瓜',
    slug: 'meiri-chigua',
    description: '今日吃瓜大赛实时更新，热点事件一网打尽',
    icon: 'ri-chat-smile-2-line',
    count: 256,
  },
  {
    id: 'mingxing-bagua',
    name: '明星八卦',
    slug: 'mingxing-bagua',
    description: '娱乐圈最新八卦资讯，明星恋情绯闻全掌握',
    icon: 'ri-star-line',
    count: 189,
  },
  {
    id: 'zongyi-husi',
    name: '综艺互撕',
    slug: 'zongyi-husi',
    description: '综艺节目撕逼大战，现场名场面回放',
    icon: 'ri-tv-line',
    count: 94,
  },
  {
    id: 'zuixin-baoliao',
    name: '最新爆料',
    slug: 'zuixin-baoliao',
    description: '最新爆料视频实时更新，第一手内幕消息',
    icon: 'ri-vidicon-line',
    count: 312,
  },
  {
    id: 'chigua-dasai',
    name: '吃瓜大赛',
    slug: 'chigua-dasai',
    description: '每日吃瓜大赛排行榜，看谁才是吃瓜王者',
    icon: 'ri-trophy-line',
    count: 76,
  },
  {
    id: 'zhibo-fanshui',
    name: '直播翻车',
    slug: 'zhibo-fanshui',
    description: '主播直播翻车现场合集，名场面不容错过',
    icon: 'ri-live-line',
    count: 145,
  },
  {
    id: 'wangluo-redian',
    name: '网络热点',
    slug: 'wangluo-redian',
    description: '全网热点事件追踪，吃瓜群众在线围观',
    icon: 'ri-radar-line',
    count: 203,
  },
];

export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  imageSeq: string;
  author: string;
  publishedAt: string;
  heat: number;
  comments: number;
  tags: string[];
  isHot: boolean;
  isExclusive: boolean;
}

export const articles: Article[] = [
  {
    id: '1',
    title: '某千万粉丝女主播直播翻车，私下辱骂粉丝录音曝光',
    slug: 'qianwan-fensi-zhubo-fanche',
    excerpt: '拥有千万粉丝的某平台头部女主播近日在直播中意外翻车，一段私下辱骂粉丝的录音被曝光，引发全网热议。录音中该主播对粉丝使用了大量侮辱性词汇，与其平时甜美形象形成巨大反差。',
    content: '近日，拥有超过千万粉丝的某短视频平台头部女主播在直播中意外翻车，一段长达三分钟的私下录音被网友曝光，内容涉及该主播对粉丝群体的大量侮辱性言论，与其在直播间中塑造的甜美、温柔人设形成强烈反差，引发全网哗然。\n\n录音曝光后迅速登上各大社交平台热搜榜，播放量突破千万。录音中，该主播用极度轻蔑的口吻谈论粉丝，称其为"韭菜""ATM机"，并表示"我就是装给他们看的，他们傻得很"。这段录音的曝光直接导致其直播间人气从百万暴跌至不足十万，大量粉丝宣布脱粉。\n\n据悉，该录音是由其前助理在某次私人聚会中偷偷录制的。前助理在社交媒体上发文称，自己终于看不下去了，要把真相公之于众。该女主播在事发后的首次直播中试图解释，称录音是"恶意剪辑""有人要害我"，但网友并不买账，弹幕中充斥着质疑和指责。\n\n事件持续发酵，已经有多个品牌方宣布暂停与该主播的合作。有业内人士透露，仅品牌合作损失就已超过两千万。目前，该主播的短视频账号已经设置了仅关注者可评论，评论区被大量负面留言占领。\n\n此事也引发了关于网红人设崩塌的广泛讨论。网友表示，现在看任何网红都需要"保留一份怀疑"，不要太快相信镜头前展现的一面。多位网络心理学专家也发表评论，称这种现象反映的是"表演型人格"在网络时代的放大效应。',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20female%20live%20streamer%20angry%20expression%20dramatic%20lighting%20dark%20studio%20background%20with%20streaming%20equipment%20ring%20light%20microphone%20intense%20emotion%20editorial%20photography%20high%20contrast%20cinematic%20mood&width=800&height=500&seq=article-01&orientation=landscape',
    imageSeq: 'article-01',
    author: '吃瓜前线',
    publishedAt: '2026-07-07',
    heat: 98500,
    comments: 3421,
    tags: ['直播翻车', '网红', '录音曝光'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: '2',
    title: '知名综艺节目录制现场爆发激烈冲突，两位导师当场翻脸',
    slug: 'zongyi-luchong-xianchang-chongtu',
    excerpt: '某知名音乐选秀综艺节目最新一期录制现场爆发严重冲突，两位常驻导师因选手评分问题当场翻脸，节目组被迫中断录制长达两小时。现场观众透露双方言辞激烈，场面一度失控。',
    content: '据多位现场观众透露，某知名音乐选秀综艺最新一期录制过程中爆发了严重冲突。两位常驻导师因为对一名人气选手的评分产生严重分歧，从最初的意见不合升级为激烈争吵，最终导致节目组被迫中断录制长达两小时。\n\n知情人士透露，冲突的直接导火索是A导师给该选手打了全场最高分，而B导师则给出了低分，理由是"音准存在明显问题"。双方在点评环节针锋相对，A导师甚至当场质问B导师"你到底懂不懂音乐"，B导师则回呛"你懂不懂什么叫专业标准"。\n\n现场气氛迅速降温。有现场观众表示，当时演播厅里的温度仿佛瞬间降到了冰点，选手站在舞台中央手足无措，其他导师也不知所措。主持人试图圆场但效果甚微。\n\n据节目组内部人员透露，事件发生后制作团队进行了紧急协商，最终决定将该冲突片段以"花絮"形式在正片中保留部分，以增加节目的戏剧张力。但也有消息称两位导师已经向节目组提出，后续录制中不再同台。\n\n此事在网上迅速发酵，#导师互撕#话题阅读量突破三亿。观众看法两极分化：一方认为节目就应该真实，这种冲突更有看点；另一方则批评导师不专业，将个人恩怨带到节目中。无论如何，该节目的收视率和话题度都因此事件获得了巨大提升。',
    category: '综艺互撕',
    categorySlug: 'zongyi-husi',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20red%20judge%20chairs%20spotlights%20dramatic%20tension%20two%20figures%20arguing%20on%20stage%20dark%20audience%20background%20reality%20show%20atmosphere%20cinematic%20lighting&width=800&height=500&seq=article-02&orientation=landscape',
    imageSeq: 'article-02',
    author: '综艺侦查员',
    publishedAt: '2026-07-06',
    heat: 76500,
    comments: 2189,
    tags: ['综艺', '冲突', '导师翻脸'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: '3',
    title: '顶流男星深夜与神秘女子同回公寓，恋情疑似曝光',
    slug: 'dingliu-nanxing-shenye-lianqing',
    excerpt: '近日有八卦媒体拍到某顶流男星深夜与一神秘女子同回公寓，两人举止亲密。该男星此前一直对外宣称单身，此次照片曝光引发粉丝激烈讨论，部分粉丝表示"房子塌了"。',
    content: '近日，某八卦媒体曝光了一组重磅照片：拥有三千多万粉丝的顶流男星深夜与一名神秘女子共同返回其位于北京朝阳区的公寓。照片中两人举止亲密，男子还贴心地为女子开门，全程有说有笑，疑似恋情曝光。\n\n该男星此前多次在公开场合表示"目前是单身状态，专注事业"，也曾多次被拍到独自出席活动。此次照片曝光后，引发粉丝群体激烈震荡。部分粉丝在社交媒体上表示"房子塌了""再也不相信爱情了"，也有部分粉丝选择支持偶像，称"30岁谈恋爱很正常"。\n\n女方身份目前尚未确认，有网友猜测是某新人女演员，也有人认为是圈外素人。爆料媒体称后续还将放出更多"实锤"照片和视频。\n\n截至目前，该男星工作室尚未对此事作出正式回应，但据悉其公关团队已经紧急开会，商讨应对策略。多位娱乐评论人预测，如果恋情属实，将对该男星的事业产生一定影响，特别是其赖以生存的"女友粉"群体可能出现流失。\n\n不过也有业内人士认为，转型期的男星适当曝光恋情反而有助于转型，摆脱"小鲜肉"标签，建立更成熟的艺人形象。无论如何，这场恋情疑云已经成为近期娱乐圈最受关注的话题之一。',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=night%20street%20scene%20in%20Chinese%20city%20two%20silhouettes%20walking%20close%20together%20paprazzi%20style%20photography%20blurry%20background%20streetlights%20warm%20glow%20mysterious%20atmosphere%20entertainment%20news&width=800&height=500&seq=article-03&orientation=landscape',
    imageSeq: 'article-03',
    author: '狗仔大队',
    publishedAt: '2026-07-06',
    heat: 123000,
    comments: 5678,
    tags: ['顶流', '恋情', '深夜'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: '4',
    title: '某电商大主播带货翻车，号称进口产品实为国内代工',
    slug: 'dianshang-zhubo-daihuo-fanche',
    excerpt: '近日某拥有500万粉丝的电商带货主播被曝出其直播间销售的"进口高端护肤品"实际为国内小作坊代工生产，成本仅十几元却售价数百元，消费者维权群已涌入数千人。',
    content: '近日，一场涉及数百万消费者的电商带货翻车事件引发广泛关注。拥有超过500万粉丝的某知名带货主播被曝出其在直播间大力推荐的"法国进口高端护肤品牌"实际为国内某小作坊代工生产，产品成本仅十几元，但直播间售价高达399元，溢价超过20倍。\n\n事件起因是有消费者在使用该产品后出现过敏反应，送检后发现成分与主播宣传的"天然有机、法国进口"严重不符。进一步调查揭露，该所谓"法国品牌"根本不存在，是一个在国内注册的"假洋牌"。\n\n目前，消费者维权群已涌入数千人，群成员来自全国各地。有消费者表示在该主播直播间累计购买了上万元的"进口"产品。律师表示，主播在直播中宣传"法国进口"等虚假内容已经涉嫌虚假宣传，消费者有权要求三倍赔偿。\n\n更令人震惊的是，据前供应链员工爆料，该主播团队其实早知道产品的真实情况，但碍于"利润率实在太好"而继续销售。爆料还指出，该主播直播间里"德国产"。\n\n目前，相关部门已经介入调查，该主播的直播间已经被平台暂停带货权限。事件仍在持续发酵中，我们将持续关注后续进展。',
    category: '最新爆料',
    categorySlug: 'zuixin-baoliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20ecommerce%20live%20streaming%20studio%20with%20skincare%20products%20displayed%20on%20desk%20ring%20light%20dramatic%20mood%20contrast%20between%20luxury%20packaging%20and%20factory%20background%20editorial%20style&width=800&height=500&seq=article-04&orientation=landscape',
    imageSeq: 'article-04',
    author: '打假先锋',
    publishedAt: '2026-07-05',
    heat: 89200,
    comments: 4532,
    tags: ['带货', '假货', '维权'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: '5',
    title: '吃瓜大赛TOP1：年度最离谱网红塌房事件大盘点',
    slug: 'chigua-dasai-niandi-pandian',
    excerpt: '2026上半年吃瓜大赛榜单新鲜出炉！从人设崩塌到法律纠纷，从感情纠葛到商业欺诈，本年度最离谱的网红塌房事件一次看完。哪些网红成功"出圈"，哪些彻底"凉凉"？',
    content: '2026年上半年的吃瓜大赛榜单正式揭晓！今年的网红塌房事件可谓花样百出、各显神通。从人设崩塌到法律纠纷，从感情纠葛到商业欺诈，每一个瓜都足以刷新吃瓜群众的三观。让我们一起来看看本年度最离谱的网红塌房事件大盘点。\n\n第一名：数据造假之王。某头部知识博主被曝出其宣称的"年薪千万""白手起家"等励志故事全部是剧本，实际年收入不到宣称的十分之一。更离谱的是，其"成功案例"的截图均为P图，粉丝们花高价购买的课程内容与网上免费资源几乎完全一致。\n\n第二名：双面人达人。某以"善良暖心"形象著称的公益博主被前团队爆料，其私下对助理恶语相向，捐款行为纯属摆拍，实际到账的公益款项不足宣传金额的20%。录音中该博主说"捐款就是为了博好感，我捐一块钱也要说成捐了一万"。\n\n第三名：假学历精英。某留学博主长期以"常青藤名校博士"自居，粉丝纷纷以"跟着学霸学知识"为由关注。后被扒出所谓"博士"学历是假的，连本科学校都是虚构的，真实学历为某三本院校肄业。\n\n第四名：带货翻车女王。某时尚穿搭博主推荐的"同款"衣服实际来自低价批发市场，粉丝购买后发现质量极差。更有爆料称她展示的"大牌包"实为高仿，A货价格不超过500元。\n\n这些塌房事件无一例外地反映了当下网红经济中的诚信危机。专家表示，随着监管趋严和消费者理性回归，未来"立人设"将越来越难，真实和专业才是长久之道。',
    category: '吃瓜大赛',
    categorySlug: 'chigua-dasai',
    imageUrl: 'https://readdy.ai/api/search-image?query=dramatic%20ranking%20list%20visual%20with%20watermelon%20motif%20red%20and%20green%20color%20scheme%20social%20media%20collapse%20symbolism%20broken%20crown%20falling%20stars%20editorial%20design%20concept%20bold%20typography&width=800&height=500&seq=article-05&orientation=landscape',
    imageSeq: 'article-05',
    author: '吃瓜评审团',
    publishedAt: '2026-07-04',
    heat: 156000,
    comments: 8921,
    tags: ['吃瓜大赛', '年度盘点', '塌房'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: '6',
    title: '短视频平台两大头部网红互撕，聊天记录完整曝光',
    slug: 'duanshipin-wanghong-husi',
    excerpt: '某短视频平台两位拥有千万级粉丝的头部网红近日在社交平台公开互撕，随后完整聊天记录被第三方曝光。记录显示两人因商业合作分成问题积怨已久，言语间火药味十足。',
    content: '近日，某短视频平台上两位拥有千万粉丝级别的头部网红在各自直播间和社交平台上公开互撕，引发了全网的围观和热议。随着第三方陆续放出完整的聊天记录，这场"网红大战"的真相逐渐浮出水面。\n\n据悉，两位网红此前是圈内好友，曾联合举办过多场商业活动和直播带货。矛盾爆发的导火索是一次大型直播带货活动后的分成纠纷。甲方A认为自己承担了大部分宣传工作，理应获得更高分成比例；乙方B则认为A的粉丝转化率远低于自己，按约定比例分钱不公平。\n\n曝光的聊天记录显示，两人在私下群聊中从最初还算理性的讨论迅速升级为互相攻击。A指责B"每次活动都迟到，还嫌分钱少"，B则回击A"粉丝全是买的僵尸粉，还好意思要更多"。之后言辞愈发激烈，涉及人身攻击和爆料对方"黑历史"。\n\n更让吃瓜群众兴奋的是，聊天记录中还意外披露了两人过往的一些"秘密操作"，包括一起购买僵尸粉、互相刷单提高排名、联合炒作CP等内幕。这些曝光对两人的形象都造成了不小的打击。\n\n事件持续发酵，目前已有超过10个品牌方宣布暂停与两位网红的合作。平台方面也介入了调查，如果核实存在刷量行为，两人的账号可能面临限流甚至封禁的处罚。这场"网红互撕"大戏的最终结局，吃瓜群众们仍在持续关注中。',
    category: '网络热点',
    categorySlug: 'wangluo-redian',
    imageUrl: 'https://readdy.ai/api/search-image?query=two%20smartphones%20displaying%20intense%20chat%20messages%20side%20by%20side%20on%20dark%20surface%20dramatic%20red%20lighting%20social%20media%20conflict%20theme%20cinematic%20composition%20high%20contrast&width=800&height=500&seq=article-06&orientation=landscape',
    imageSeq: 'article-06',
    author: '聊天记录侠',
    publishedAt: '2026-07-03',
    heat: 67800,
    comments: 2345,
    tags: ['网红互撕', '聊天记录', '短视频'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: '7',
    title: '某综艺女嘉宾录制中途罢录，导演组紧急更换人选',
    slug: 'zongyi-nvjiabin-balu',
    excerpt: '据现场工作人员爆料，某热门恋爱综艺女嘉宾在最新一期录制中因不满节目组恶意剪辑而当场罢录，导致录制中断。节目组被迫紧急联系备选嘉宾救场，该期节目或将延期播出。',
    content: '据多位参与录制的现场工作人员爆料，某热门恋爱真人秀综艺的最新一期录制过程中发生了突发状况。一位人气颇高的女嘉宾因不满节目组对其形象的恶意剪辑以及剧本走向安排，在录制中途突然宣布罢录，导致录制被迫中断。\n\n据知情人士透露，该女嘉宾在录制到"告白环节"时，发现节目组给她的"台词"与此前沟通的内容严重不符，明显是在将她塑造成一个"绿茶"形象。此前播出的先导片中已经出现了一些对嘉宾不太友好的剪辑，该女嘉宾当时就通过社交账号表达过不满，但被节目组以"节目效果"为由搪塞过去。\n\n罢录事件发生后，节目组在长达两小时的等待后决定联系备选嘉宾救场。据悉备选嘉宾是之前被淘汰的一位女选手，接到电话后立刻赶到现场完成剩余录制。但原有的一些互动环节因为嘉宾更换而无法继续，节目组不得不临时调整录制方案。\n\n该女嘉宾罢录的消息很快在网上传开，粉丝和网友纷纷声援，认为节目组不应该通过剪辑来伤害嘉宾形象。也有部分观众持不同意见，认为参加综艺就应该遵守"游戏规则"。目前，该综艺的官方微博已经发布声明，称"因技术原因导致录制延期"，但对罢录事件只字未提。该期节目预计将延期一周播出，具体处理方式仍待观察。',
    category: '综艺互撕',
    categorySlug: 'zongyi-husi',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20chaos%20scene%20woman%20walking%20away%20from%20set%20cameras%20scattered%20crew%20members%20looking%20worried%20dramatic%20lighting%20reality%20show%20production%20crisis%20atmosphere&width=800&height=500&seq=article-07&orientation=landscape',
    imageSeq: 'article-07',
    author: '综艺前线',
    publishedAt: '2026-07-02',
    heat: 54300,
    comments: 1876,
    tags: ['罢录', '综艺', '女嘉宾'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: '8',
    title: '知名美食博主被曝食材造假，高端餐厅测评全是剧本',
    slug: 'meishi-bozhu-shicai-zaojia',
    excerpt: '一位拥有300万粉丝的美食测评博主被前团队成员爆料，其所有"高端餐厅探店"视频均为剧本拍摄，所谓的顶级食材实为普通食材调包。该博主合作的数十家餐厅也因此受到质疑。',
    content: '近日，一位拥有300万粉丝的美食测评博主遭遇塌房危机。其前团队成员在社交媒体上爆料称，该博主所有看似真实的"高端餐厅探店"视频实际上都是精心编排的剧本，视频中展示的所谓顶级食材与实际供应给普通顾客的食材存在巨大差异。\n\n爆料指出，在拍摄"探店"视频时，博主团队会提前与餐厅沟通，要求餐厅提供外观更好、品质更高的"特制菜品"用于拍摄，而普通顾客实际吃到的则是正常出品的菜品。更夸张的是，某些视频中展示的"进口和牛""野生松茸"等高端食材，在拍摄结束后会归还餐厅，博主并不会真正品尝。\n\n消息曝光后迅速引发连锁反应。与该博主合作过的数十家餐厅纷纷受到网友的质疑和"围攻"，不少餐厅被迫在评论区声明自己与该博主"从未有过合作关系"。但也有网友表示，很多高端餐厅的探店视频看起来都"太完美了"，早就怀疑其中有水分。\n\n该博主在事发后发布了一条视频进行"澄清"，坚称自己的探店内容"真实客观"，并称前助理是因为"被辞退后心怀不满"才恶意爆料。但网友注意到，该"澄清"视频的文案和表达方式与某MCN机构的标准模板高度相似，反而更加坐实了团队化运营、脚本化拍摄的质疑。\n\n此事件也引发了关于美食探店类内容真实性的广泛讨论。专家表示，这类"付费探店"模式下，内容创作者与商家之间存在利益关联，难以做到完全客观公正，消费者在参考此类内容时需要保持理性。',
    category: '最新爆料',
    categorySlug: 'zuixin-baoliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=food%20photography%20studio%20setup%20with%20camera%20and%20lighting%20equipment%20fake%20luxury%20dining%20scene%20revealed%20behind%20the%20scenes%20contrast%20between%20glamorous%20front%20and%20chaotic%20backstage%20cinematic&width=800&height=500&seq=article-08&orientation=landscape',
    imageSeq: 'article-08',
    author: '打假先锋',
    publishedAt: '2026-07-01',
    heat: 41200,
    comments: 1534,
    tags: ['美食博主', '造假', '测评'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: '9',
    title: '直播平台一姐宣布退网，背后真相令人唏嘘',
    slug: 'zhibo-yijie-tuiwang',
    excerpt: '某直播平台常年霸榜的"一姐"级主播突然在直播间宣布永久退网，泪洒直播间。据知情人士透露，其退网原因与平台合同纠纷及个人健康问题有关，数百万粉丝纷纷表示不舍。',
    content: '近日，某直播平台的"一姐"级主播——常年霸榜、拥有超过两千万粉丝的王牌主播，在一场看似平常的直播中突然宣布永久退网。消息一出，直播间瞬间涌入数十万观众，弹幕刷屏，礼物特效不断，场面令人动容。\n\n据现场观看的粉丝描述，该主播在直播中情绪逐渐失控，从最初的"感谢大家一路陪伴"到后来的"我真的撑不下去了"，最后泪洒直播间。她坦言自己已经很久没有好好睡过一觉，每天醒来第一件事就是看数据、担心掉粉、焦虑明天播什么内容。\n\n知情人士透露，此次退网的直接导火索是与平台之间的合同纠纷。据悉，该主播与平台的续约谈判陷入僵局，平台方面要求大幅提高直播时长和带货指标，而该主播因长期高强度工作已出现严重的健康问题，无法满足新的要求。双方僵持不下，最终导致主播选择退出。\n\n更令人唏嘘的是，有前经纪人爆料，该主播在过去三年中几乎没有休息日，每天直播时长超过8小时，下播后还要处理商务合作、粉丝运营等事务，日均工作时间超过14小时。长期的透支让这位年轻的主播身体亮起了红灯，医生建议她立即停止高强度工作。\n\n退网消息发布后，数百万粉丝在社交平台上表达了不舍之情。很多网友留言"一路走好""保重身体""等你回来"，也有不少网友表示对直播行业的残酷有了更深的认识。该主播在最后的告别动态中写道："谢谢大家让我体验过那么多高光时刻，现在是时候做回普通人了。"',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=female%20streamer%20emotional%20farewell%20moment%20tears%20on%20face%20dark%20studio%20with%20dim%20ring%20light%20melancholy%20atmosphere%20streaming%20setup%20visible%20goodbye%20message%20on%20screen%20cinematic&width=800&height=500&seq=article-09&orientation=landscape',
    imageSeq: 'article-09',
    author: '吃瓜前线',
    publishedAt: '2026-06-30',
    heat: 72300,
    comments: 2987,
    tags: ['退网', '直播', '一姐'],
    isHot: false,
    isExclusive: false,
  },
];

export const hotRankings = [
  { rank: 1, title: '某千万粉丝女主播直播翻车', heat: '98.5w', slug: 'qianwan-fensi-zhubo-fanche', imageSeq: 'rank-01' },
  { rank: 2, title: '顶流男星深夜同回公寓', heat: '123w', slug: 'dingliu-nanxing-shenye-lianqing', imageSeq: 'rank-02' },
  { rank: 3, title: '电商大主播带货翻车假货门', heat: '89.2w', slug: 'dianshang-zhubo-daihuo-fanche', imageSeq: 'rank-03' },
  { rank: 4, title: '年度最离谱塌房大盘点', heat: '156w', slug: 'chigua-dasai-niandi-pandian', imageSeq: 'rank-04' },
  { rank: 5, title: '综艺录制现场导师翻脸', heat: '76.5w', slug: 'zongyi-luchong-xianchang-chongtu', imageSeq: 'rank-05' },
];

export const testimonials = [
  {
    name: '资深瓜友 - 小李',
    content: '自从发现了51在线吃瓜，每天上班第一件事就是打开看看今天有什么新瓜。更新速度全网最快，内容也够劲爆，同事们都在看！',
    avatar: 'ri-user-3-line',
  },
  {
    name: '娱乐博主 - 八卦君',
    content: '作为同行，我不得不承认51在线吃瓜的爆料深度确实厉害。很多独家线索都是从这里首发，然后再被全网转发。吃瓜界的标杆！',
    avatar: 'ri-user-3-line',
  },
  {
    name: '普通网友 - 吃瓜不嫌事大',
    content: '页面干净没广告弹窗，阅读体验很好。每天都有新内容，分类也很清楚，想看哪个圈子的瓜直接点进去就行，非常方便。',
    avatar: 'ri-user-3-line',
  },
];